import { render } from "./DevicesTableBasic.vue?vue&type=template&id=2d19389f"
import script from "./DevicesTableBasic.vue?vue&type=script&lang=js"
export * from "./DevicesTableBasic.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__